import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import NewTabBar from '../components/NewTabBar';

// 路由守卫逻辑
const MainLayout: React.FC = () => {
  const location = useLocation();
  
  // 检查用户是否已登录，这里简单判断localStorage中是否有token
  const isAuthenticated = localStorage.getItem('token') !== null;
  
  // 如果未登录，重定向到登录页
  if (!isAuthenticated) {
    // 将用户要访问的页面路径保存到state中，登录成功后可以跳转回来
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      {/* 路由出口，嵌套的子路由会在这里渲染 */}
      <main style={{ paddingBottom: '0px' }}>
        <Outlet />
      </main>
      
      {/* 底部导航栏 */}
      <NewTabBar />
    </>
  );
};

export default MainLayout; 